import React from 'react';
import classNames from 'classnames';
import { Tag } from 'antd';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import styles from '@pages/api-portal/styles.module.scss';
import { MethodBadge } from '@pages/api-portal/method-badge';
import { StatusBadge } from '@pages/api-portal/status-badge';
import { formatCatalogDate } from '@pages/api-portal/utils';
import { ApiEndpoint } from '@pages/api-portal/types';

interface EndpointRowProps {
    endpoint: ApiEndpoint;
    onEdit: (endpoint: ApiEndpoint) => void;
    onDelete: (endpoint: ApiEndpoint) => void;
}

/*
 * One row in the API Endpoints manager list, with edit/delete actions.
 */
export function EndpointRow({ endpoint, onEdit, onDelete }: EndpointRowProps) {
    return (
        <div className={styles.cardSplit} style={{ marginBottom: 8 }}>
            <div className={styles.cardSplitBody}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <MethodBadge method={endpoint.method} />
                    <strong style={{ color: '#fff' }}>{endpoint.name}</strong>
                    {endpoint.status && endpoint.status !== 'stable' && <StatusBadge status={endpoint.status} />}
                </div>
                <code className={styles.mutedText} style={{ fontSize: 12 }}>
                    {endpoint.path}
                </code>
                <p className={styles.mutedText} style={{ margin: '4px 0' }}>
                    {endpoint.description}
                </p>
                <div>
                    {endpoint.tags.map((tag) => (
                        <Tag key={tag}>{tag}</Tag>
                    ))}
                </div>
            </div>
            <div className={styles.cardSplitFooter}>
                <span className={styles.mutedText} style={{ fontSize: 12 }}>
                    Created {formatCatalogDate(endpoint.created)} · Updated {formatCatalogDate(endpoint.updated)}
                </span>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                    <button type="button" className={classNames(styles.iconButton, styles.editAction)} onClick={() => onEdit(endpoint)}>
                        <AiOutlineEdit />
                    </button>
                    <button
                        type="button"
                        className={classNames(styles.iconButton, styles.deleteAction)}
                        onClick={() => onDelete(endpoint)}
                    >
                        <AiOutlineDelete />
                    </button>
                </div>
            </div>
        </div>
    );
}
